import { DomainBranding } from '@rygen/rygen-ui/model';

import { buildShipmentEvent } from '@/util';

import { Carrier } from '../Carrier';
import { Contact } from '../Contact';
import { ReferenceNumber } from '../ReferenceNumber';
import { ShipmentEvent } from '../shipmentEvent/ShipmentEvent';
import { ShipmentServiceIncident } from '../shipmentEvent/ShipmentServiceIncident';
import { ShippingPoint } from '../ShippingPoint';

import { ShipmentLineItem } from './ShipmentLineItem';
import { ShipmentStatus } from './ShipmentStatus';
import { ShipmentStop } from './ShipmentStop';
import { ShipmentStopType } from './ShipmentStopType';

export class ShipmentTrackingSummary {
  id?: number;
  status?: ShipmentStatus;
  domainBranding?: DomainBranding;
  carrier?: Carrier;
  contact?: Contact;
  stops: ShipmentStop[] = [];
  referenceNumbers: ReferenceNumber[] = [];
  events: ShipmentEvent[] = [];
  incidents: ShipmentServiceIncident[] = [];
  requireBothArrivalAndDepartureOnStops = false;

  constructor(opts?: Partial<ShipmentTrackingSummary>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.status != null) {
      this.status = opts.status;
    }
    if (opts?.domainBranding != null) {
      this.domainBranding = new DomainBranding(opts.domainBranding);
    }
    if (opts?.carrier != null) {
      this.carrier = new Carrier(opts.carrier);
    }
    if (opts?.contact != null) {
      this.contact = new Contact(opts.contact);
    }

    if (opts?.stops?.length) {
      this.stops = opts.stops.map((val) => new ShipmentStop(val));
    } else {
      this.stops = [new ShipmentStop(), new ShipmentStop()];
    }

    if (opts?.referenceNumbers != null) {
      this.referenceNumbers = opts.referenceNumbers.map(
        (val) => new ReferenceNumber(val),
      );
    }
    if (opts?.events != null) {
      this.events = opts.events.map(buildShipmentEvent);
    }
    if (opts?.incidents != null) {
      this.incidents = opts.incidents.map(
        (val) => new ShipmentServiceIncident(val),
      );
    }
    if (opts?.requireBothArrivalAndDepartureOnStops != null) {
      this.requireBothArrivalAndDepartureOnStops =
        opts.requireBothArrivalAndDepartureOnStops;
    }
  }

  get origin() {
    return this.stops[0];
  }

  get destination() {
    return this.stops[this.stops.length - 1];
  }

  get lineItems(): ShipmentLineItem[] {
    return [];
  }

  getLineItemsForStop(stop: ShippingPoint): ShipmentLineItem[] {
    const isPickup = stop.stopType === ShipmentStopType.PICKUP;
    const seqNumKey = isPickup
      ? 'pickupStopSequenceNumber'
      : 'dropOffStopSequenceNumber';
    return this.lineItems.filter((l) => l[seqNumKey] === stop.sequenceNumber);
  }
}
